import useStyles from 'isomorphic-style-loader/useStyles';
import { createRef, useMemo } from 'react';
import { useIsClient } from 'usehooks-ts';

import s from './offset-anchor.scss';

// This is a workaround to get the value of the TopNav plus the top custom banner height
// The CSS variable uses a calc which we can't access from JS

const pageOffsetAnchorRef = createRef<HTMLDivElement>();

// To get the value of a CSS calc we have to render an element
// The className hides this element and sets the CSS variable to the element's 'top' property
export const PageOffsetAnchor = () => {
  useStyles(s);
  return <div ref={pageOffsetAnchorRef} className={s.container} />;
};

// Once the element is rendered we can get the value of the CSS variable
export const useComputedPagePaddingTopPx = () => {
  const isClient = useIsClient();

  return useMemo(
    () =>
      isClient ? pageOffsetAnchorRef.current?.getBoundingClientRect().top : 0,
    [isClient],
  );
};
